import { render, staticRenderFns } from "./tag-selector.vue?vue&type=template&id=71b2b16c"
import script from "./tag-selector.vue?vue&type=script&lang=js"
export * from "./tag-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports